import React from "react";

import think from "../../../../app/assets/images/idea-booster/think.png";

const Hero = () => {
  return (
    <>
      <style jsx>{``}</style>

      {/* Your App Journey Section Start Here */}
      <div class="wg-result bg-black cust-padding border-line-btm">
        <div class="themesflat-container">
          <div class="row justify-content-center">
            <div class="content text-center">
              <div class="heading-section wow fadeInUp style-2">
                <div class="sub-title text-gradient">
                  We Bring to Your App Journey
                </div>
                <div class="main-title title">
                  <h2 class="mb-0 section-head">
                    What{" "}
                    <img src={think} class="rocket-gif ms-0" alt="ib-img" />
                    Value Do We Add?
                  </h2>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="cust-width">
                <ul class="value-sec-list">
                  <li>
                    <b class="text-gradient">Refinement and Cost-Efficiency:</b>{" "}
                    Use Idea Booster to sharpen your project's focus and ensure
                    efficient use of your budget.
                  </li>
                  <li>
                    <b class="text-gradient">
                      Early User Feedback Integration:
                    </b>{" "}
                    Avoid costly development mistakes by validating features
                    with real user insights from the start.
                  </li>
                  <li>
                    <b class="text-gradient">Focus on What Matters:</b> Our
                    method ensures your project concentrates on functionalities
                    that truly resonate with your audience.
                  </li>
                  <li>
                    <b class="text-gradient">
                      Deep Dive into User Requirements:
                    </b>{" "}
                    Uncover new opportunities and gain a deep market
                    understanding to align with user needs and expectations.
                  </li>
                  <li>
                    <b class="text-gradient">Leverage Proven Success:</b>{" "}
                    Benefit from our experience in launching successful
                    products, utilizing insights on captivating functionalities,
                    user confidence strategies, and optimal technologies.
                  </li>
                  <li>
                    <b class="text-gradient">Innovate with Confidence:</b> Save
                    significantly while pushing the boundaries of innovation,
                    ensuring your offering deeply connects with target users and
                    distinguishes itself in a competitive market.
                  </li>
                  <li class="mb-0">
                    <b class="text-gradient">
                      Strategic, User-Centered Development:{" "}
                    </b>
                    Achieve a development process that's not just financially
                    prudent but also positions you as a leader in innovation and
                    market relevance.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Section End Here */}
    </>
  );
};

export default Hero;
